<template>
    <div class="h-screen w-screen">
        <slot>Loading content</slot>
    </div>
</template>
